import type { Action } from "../pb/mj/record/v1/record_pb";
import { ActionType } from "../pb/mj/record/v1/record_pb";

/** A call's tiles in order, the one taken among them: "5 4 6" read as nothing, 4 5 6 as a run. */
export function callTiles(a: Action, called: number | undefined): number[] {
  const takes = a.type === ActionType.CHI || a.type === ActionType.PON || a.type === ActionType.OPEN_KAN;
  return (takes && called !== undefined && !a.tiles.includes(called) ? [...a.tiles, called] : [...a.tiles]).sort((x, y) => x - y);
}

/** More buttons than this and several chi are folded behind one: the rest would run off a small phone, the hand with them. */
const MOST_BUTTONS = 5;
export const foldsChi = (legal: Action[]): boolean => {
  const shown = legal.filter((a) => a.type !== ActionType.DISCARD);
  return shown.filter((a) => a.type === ActionType.CHI).length > 1 && shown.length > MOST_BUTTONS;
};
